import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import * as Video from '@ClientBase/Generic/VideoUtils'
import * as Animations from './Animations'
import * as Carousels from './Carousels'
import * as JobTile from './Jobs/Tile'
import * as JobFilters from './Jobs/Filters'
import * as Modal from './Modal'
import * as Navigation from './Navigation'
import * as PostFilters from './Posts/Filters'
import * as PostWidget from './Posts/Widget'
import * as SocialProfile from './SocialProfileWidget'
import * as StickyApply from './StickyApply'
import * as Home from './Home'
import * as ShareWidget from './ShareWidget'
import * as Shortlist from './Shortlist'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetContent from './Content/Content'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetIconsText from './IconsText/IconsText'
import SnippetImage from './Image/Image'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetImageContentIcon from './ImageContentIcon/ImageContentIcon'
import SnippetHeading from './Heading/Heading'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetSpacer from './Spacer/Spacer'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetVideo from './Video/Video'
import SnippetParagraph from './Paragraph/Paragraph'
import SnippetSingleLink from './SingleLink/SingleLink'
import SnippetStatistic from './Statistic/Statistic'
import SnippetBrandsCarousel from './BrandsCarousel/BrandsCarousel'
import SnippetGallery from './Gallery/Gallery'
import SnippetHiringProcess from './HiringProcess/HiringProcess'
import SnippetCards from './Cards/Cards'
import SnippetImageCards from './ImageCards/ImageCards'
import SnippetBenefits from './Benefits/Benefits'
import SnippetGalleryCarousel from './GalleryCarousel/GalleryCarousel'

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const VIDEO_ROOT_CLASS = "page-job-details__banner-cta-video";

const _Components = {
    'SnippetAccordion': SnippetAccordionReact,
    'SnippetContent': SnippetContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetIconsText': SnippetIconsText,
    'SnippetImage': SnippetImage,
    'SnippetImageContent': SnippetImageContent,
    'SnippetImageContentIcon': SnippetImageContentIcon,
    'SnippetHeading': SnippetHeading,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetSpacer': SnippetSpacer,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetVideo': SnippetVideo,
    'SnippetParagraph': SnippetParagraph,
    'SnippetSingleLink': SnippetSingleLink,
    'SnippetStatistic': SnippetStatistic,
    'SnippetBrandsCarousel': SnippetBrandsCarousel,
    'SnippetGallery': SnippetGallery,
    'SnippetHiringProcess': SnippetHiringProcess,
    'SnippetCards': SnippetCards,
    'SnippetImageCards': SnippetImageCards,
    'SnippetBenefits': SnippetBenefits,
    'SnippetGalleryCarousel': SnippetGalleryCarousel,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.initialise()
        Shortlist.initialise()
        JobTile.initialise()
        JobFilters.initialise()
        PostFilters.initialise()
        PostWidget.initialise()
        Carousels.initialise()
        StickyApply.initialise()
        SocialProfile.initialise()
        Modal.initialise()
        Video.initVideoModals(VIDEO_ROOT_CLASS, true)
        Home.initialise()
        ShareWidget.initialise()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
        window.addEventListener('load', () => {
            Animations.initialise()
        })
    },
})